<script>
    import { selectedCarePlan } from '../stores.js';
    import Rating from './Rating.svelte';

    export let plan;
    export let isSelected;

    function toggle() {
		isSelected = !isSelected;
	}

    function setSelected() {
        $selectedCarePlan = plan;
	}
</script>


<div class="tile {$selectedCarePlan === plan ? 'active' : ''}" on:click={toggle} on:click={setSelected}>
    {#if plan.isFeatured}
        <div class="featured">
            <span>Populaire</span>
        </div>
    {/if}
    <h2>{plan.title}</h2>
    <div class="description">
        {@html plan.description}
    </div>
    <div class="ratings">
        <span>Sécurité</span><Rating max={5} value="{plan.security}"/>        
        <span>Services</span><Rating max={5} value="{plan.services}"/>
    </div>
    <div class="pricing">
        <span class="price">{plan.price}€</span><br>
        <span class="price-info">ht/mois</span>
    </div>
    <div class="details">
        <h3>Maintenance & securité</h3>
        {@html plan.detailServices}
        <h3>support & Suivi</h3>
        {@html plan.detailHelp}
    </div>
</div>


<style>
    .tile {
        border: solid 5px transparent;
        padding: 14px;
        padding-bottom: 32px;
        background: #fff;
        cursor: pointer;
        position: relative;
    }
    .tile.active {
        border: solid 5px #10284B;
    }
    .description{
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        color: #859DB7;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 16px;
    }
    .ratings{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 10px;
        justify-items: start;
        margin: 16px 0;
        display: none;
    }
    .pricing {
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .price{
        font-weight: bold;
        font-size: 18px;
        font-family: Georgia, 'Times New Roman', Times, serif;
    }
    .price-info {
        color: #859DB7;
        font-size: 14px;
    }
    .details {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    .details h3 {
        color: #10284B;
        font-weight: bold;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        margin-top: 24px;
        margin-bottom: 7px;
    }
    .details {
        color: #859DB7;
        font-size: 12px;
    }
    .details :global(b) {
        color: #10284B;
        font-weight: normal;
    }

    .featured {
        position: absolute;
        top: -18px;
        left: 0;
        width: 100%;
    }
    .featured span {
        background-color: #10284B;
        padding: 4px 8px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        color: #859DB7;
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 0.1em;
        font-weight: bold;
    }

</style>
